var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loading)?_c('div',{staticClass:"d-flex justify-content-center align-items-center",staticStyle:{"height":"calc(100vh - 80px)","flex-direction":"column"}},[_c('b-spinner',{attrs:{"label":_vm.$t('loadingPage')}})],1):(_vm.page && _vm.page.id)?_c('div',{staticClass:"px-3",domProps:{"innerHTML":_vm._s(_vm.page.body)}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }